import { CommonStore } from '@udemy/store-provider';
import { udApi } from '@udemy/ud-api';

// Currently this module only handles settings for the current (logged in) user.

// Values to set in the DB.
// Corresponds to values in udemy/user/constants/model.py
// Remember, JS objects treat all keys as string.
/* eslint-disable @typescript-eslint/no-explicit-any */
export const ON_NULL_MAP = {
  [true]: 'on',
  [false]: null
};
export const TRUE_FALSE_MAP = {
  [true]: '1',
  [false]: ''
};
export const ON_OFF_MAP = {
  [true]: 'on',
  [false]: 'off'
};
/* eslint-enable @typescript-eslint/no-explicit-any */

// When fetching a value from udMe.settings, these values will correspond to true or false respectively.
const TRUE_VALUES = ['on', '1'];
const FALSE_VALUES = ['off', '', null];
export const SETTINGS = Object.freeze({
  captionEditorPauseWhenTyping: Object.freeze({
    settingCode: 'caption-editor-pause-when-typing',
    valueMap: ON_NULL_MAP,
    defaultValue: true
  }),
  directMessagingEnabled: Object.freeze({
    settingCode: 'direct_messaging_enabled',
    valueMap: ON_NULL_MAP,
    defaultValue: true
  }),
  dismissOccupationCollectionBanner: Object.freeze({
    settingCode: 'dismissOccupationCollectionBanner',
    valueMap: ON_OFF_MAP,
    defaultValue: false
  }),
  interstitialAutoplay: Object.freeze({
    settingCode: 'interstitialAutoNext',
    valueMap: ON_NULL_MAP,
    defaultValue: true
  }),
  instructorCoursesOrdering: Object.freeze({
    settingCode: 'instructor-courses-ordering',
    valueMap: undefined,
    defaultValue: '-created'
  }),
  mfaEnabled: Object.freeze({
    settingCode: 'mfa-enabled',
    valueMap: ON_OFF_MAP,
    defaultValue: true
  }),
  reviewPromptDisabled: Object.freeze({
    settingCode: 'review-prompt-disabled',
    valueMap: TRUE_FALSE_MAP,
    defaultValue: false
  }),
  seenOnboardingFlow: Object.freeze({
    settingCode: 'seenOnboardingFlow',
    valueMap: ON_OFF_MAP,
    defaultValue: false
  }),
  seenOrgOrPPGoalHeader: Object.freeze({
    settingCode: 'seenOrgOrPPGoalHeader',
    valueMap: ON_OFF_MAP,
    defaultValue: false
  }),
  skippedOccupationFlow: Object.freeze({
    settingCode: 'skipped-occupation-flow',
    valueMap: TRUE_FALSE_MAP,
    defaultValue: false
  })
});
export class UserSettingsStore extends CommonStore {
  constructor() {
    super({
      enableLazyInit: true
    });
    this.settings = {};
    this.handleUserContextReady = () => {
      var _this$udData;
      // istanbul ignore next
      this.settings = (_this$udData = this.udData) === null || _this$udData === void 0 ? void 0 : _this$udData.me.settings;
    };
    this.onUserContextReady(() => {
      this.handleUserContextReady();
    });
  }
  get(setting, defaultValueOverride = undefined) {
    const backendSettingValue = this.settings[setting.settingCode];

    // account for `instructorCoursesOrdering` setting
    if (!setting.valueMap) {
      return backendSettingValue;
    }
    if (backendSettingValue !== undefined) {
      if (TRUE_VALUES.includes(backendSettingValue)) {
        return true;
      }
      if (FALSE_VALUES.includes(backendSettingValue)) {
        return false;
      }
    }
    if (defaultValueOverride !== undefined) {
      return defaultValueOverride;
    }
    return setting.defaultValue;
  }
  async set(setting, value, courseId = null) {
    let endPoint = '/users/me/settings/';
    if (courseId) {
      endPoint = `/users/me/course/${courseId}/settings/`;
    }
    if (setting.valueMap) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      value = setting.valueMap[value];
    }
    await udApi.post(endPoint, {
      setting: setting.settingCode,
      value
    }).then(() => {
      this.settings[setting.settingCode] = value;
    });
  }
}
UserSettingsStore.STORE_ID = 'UserSettingsStore';
UserSettingsStore.SETTINGS = SETTINGS;
//# sourceMappingURL=user-settings-store.js.map